export interface SortByType {
  ColumnToSort?: string;
  SortDirection?: SortDirectionEnum;
}

export enum SortDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}
